import {
  faPencilAlt,
  faTimesCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getBillingShippingAddress,
  profilePostAction,
} from "../../actions/profileAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getUserDetail } from "../../utils/helper";
import AddressPopup from "./AddressPopup";
import AddCustomer from "./AddCustomer";
import { acumaticaPostAction } from "../../actions/acumaticaAction";
const AddressListPopup = ({
  closePopup,
  activeAddress,
  setActiveAddress,
  setAnotherActiveAddress,
  anotherActiveAddress,
}) => {
  const dispatch = useDispatch();
  const addressList = useSelector((state) => state.profile.addressList);
  const [selectedAddress, setSelectedAddress] = useState(activeAddress);
  const [editAddress, setEditAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showEditConfirmDialog, setShowEditConfirmDialog] = useState(false);
  const [listChanged, setListchanged] = useState(false);
  const handlAddressChange = (e) => {
    setSelectedAddress(
      addressList.filter((x) => x.address_id == e.target.value)[0]
    );
  };
  const handleEditAddress = (id) => {
    let address = addressList.filter((x) => x.address_id == id)[0];
    setEditAddress(address);
    if (address?.isSubscription) {
      setShowEditConfirmDialog(true);
    } else {
      setShowAddressModal(true);
    }
  };
  const handleDeleteAddress = (id) => {
    let address = addressList.filter((x) => x.address_id == id)[0];
    setEditAddress(address);
    setShowConfirmDialog(true);
  };
  const deleteAddress = () => {
    var params = {
      params: {
        action: "userDeleteBillingShipping",
        data: {
          address_id: editAddress.address_id,
          customerId: getUserDetail()?.customerId,
          locationId: editAddress.locationId,
        },
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      acumaticaPostAction(params, () => {
        dispatch(
          getBillingShippingAddress(() => {
            if (activeAddress.address_id == editAddress.address_id) {
              setActiveAddress(null);
            }
            if (setAnotherActiveAddress && anotherActiveAddress) {
              if (anotherActiveAddress.address_id == editAddress.address_id) {
                setAnotherActiveAddress(null);
              }
            }

            dispatch(
              getBillingShippingAddress(() => {
                setListchanged(true);
              })
            );
          })
        );
      })
    );
  };

  useEffect(() => {
    if (listChanged) {
      if (!addressList.some((x) => x.address_id == activeAddress?.address_id)) {
        setActiveAddress(addressList[0]);
      }
      if (anotherActiveAddress) {
        if (
          !addressList.some(
            (x) => x.address_id == anotherActiveAddress?.address_id
          )
        ) {
          setAnotherActiveAddress(addressList[0]);
        }
      }
      setSelectedAddress(addressList[0]);
      setListchanged(false);
    }
  }, [listChanged]);

  const addressListInfo = addressList?.map((x) => (
    <div key={x.address_id} className="address-item">
      <div className="labels">
        <input
          type="radio"
          name="address"
          id={x.address_id}
          value={x.address_id}
          checked={selectedAddress?.address_id == x.address_id}
          onChange={handlAddressChange}
        />
        <label htmlFor={x.address_id}>
          {x?.first_name}
          {x?.last_name}
          {", "}
          {x?.address_1}
          {", "}
          {x?.address_2 && `Apt ${x?.address_2},`} {x?.city}, {x?.state}{" "}
          {x?.zip}
        </label>
      </div>
      <div className="actions">
        <FontAwesomeIcon
          icon={faPencilAlt}
          color="#00a65a"
          onClick={() => handleEditAddress(x.address_id)}
        />
        <FontAwesomeIcon
          icon={faTrashAlt}
          color="#dd4b39"
          onClick={() => handleDeleteAddress(x.address_id)}
        />
      </div>
    </div>
  ));
  return (
    <Modal size="lg" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Choose Address</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>
      {showAddressModal && (
        <AddressPopup
          fromBilling={false}
          setListChanged={setListchanged}
          addressInfo={editAddress}
          closePopup={() => setShowAddressModal(false)}
        />
      )}
      {addressList?.length > 0 && (
        <Modal.Body>
          <>
            {showConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to delete this address?"
                acceptAction={deleteAddress}
                acceptText="yes"
                rejectText="no"
                closePopup={() => setShowConfirmDialog(false)}
                note={
                  editAddress?.isSubscription
                    ? "Note, this Address is currently being used for your subscription. You will need to update your subscription payment address for it to renew after the current period."
                    : null
                }
              />
            )}
            {showEditConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to edit this address?"
                acceptAction={() => setShowAddressModal(true)}
                acceptText="yes"
                rejectText="no"
                closePopup={() => {
                  setShowEditConfirmDialog(false);
                }}
              />
            )}
            {addressListInfo}
          </>
        </Modal.Body>
      )}

      <div className="address-submit-section">
        {addressList?.length > 0 && (
          <button
            className="btn-orange mr-4"
            onClick={() => {
              setActiveAddress(selectedAddress);
              closePopup();
            }}
          >
            Select
          </button>
        )}
        <button
          className="btn-orange"
          onClick={() => {
            setEditAddress(null);
            setShowAddressModal(true);
          }}
        >
          Add New
        </button>
      </div>
    </Modal>
  );
};
export default AddressListPopup;
